import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LobbyStatusTileComponent } from './lobby-status-tile/lobby-status-tile.component';
import { LobbyStatusWaitCountTileComponent } from './lobby-status-wait-count-tile/lobby-status-wait-count-tile.component';
import { LobbyStatusBarComponent } from './lobby-status-bar.component';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { lobbyStatusBarReducer } from './state/lobby-status-bar.reducer';
import { LobbyStatusBarEffects } from './state/lobby-status-bar.effects';
import { AppStatTimerComponent } from './app-stat-timer/app-stat-timer.component';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [LobbyStatusBarComponent, LobbyStatusTileComponent, LobbyStatusWaitCountTileComponent,AppStatTimerComponent],
  imports: [
    CommonModule,
    StoreModule.forFeature('lobbyStatusBar', lobbyStatusBarReducer),
    EffectsModule.forFeature([LobbyStatusBarEffects]),
    TranslateModule
  ],
  exports: [
    LobbyStatusBarComponent,
    AppStatTimerComponent,
    TranslateModule
  ],
})
export class LobbyStatusBarModule { }
